<template>
    <p class="share-links">
        <a
            v-for="(shareLink, index) in shareLinks.slice(0, 3)"
            :key="shareLink.id + '-' + index"
            class="iconfont"
            :class="shareLink.icon"
            :href="shareLink.url"
            :aria-label="shareLink.socialNetwork"
            target="_blank"
            rel="noopener noreferrer"
            @click.stop
        ></a>
    </p>
</template>

<script>
import { ICON_MAP_WITH_AGENT as SPECIAL_ICON_MAP } from '../icon-map';
import util from '@/common/util.js'
export default {
    props: {
        socialNetworks: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        shareLinks() {
            let list = util.deepClone(this.socialNetworks);
            const shareLinks = list.filter(item => {
                item.icon =
                    SPECIAL_ICON_MAP[item.socialNetwork] ||
                    'icon-agent-' + item.socialNetwork;
                return !!item.socialNetwork && !!item.url;
            });
            return shareLinks;
        }
    }
};
</script>

<style lang="scss">
@import '@/theme/media.scss';
.md-team.template6-list {
    .share-links {
        width: 100%;
        padding: 0 10px;
        text-align: center;
        .iconfont {
            display: inline-flex;
            margin-bottom: 0;
            margin-right: 15px;
            border-radius: 50%;
            overflow: hidden;
            font-size: 16px;
            text-align: center;
            color: #fff;
            background: transparent;
            cursor: pointer;
            align-items: center;
            justify-content: center;
            @include media-600 {
                width: 26px;
                height: 26px;
                margin-right: 10px;
                font-size: 12px;
            }
            &:last-child {
                margin-right: 0;
            }
        }
        .icon-agent-zillow,
        .icon-agent-yelp {
            font-size: 14px;
        }
        .icon-instagram-square {
            font-size: 18px;
        }
    }
}
</style>
